import React from 'react'

import { IconName } from 'Components/Icon/Icon'
import { IconButton } from 'Components/IconButton'

type Props = {
  children: React.ReactNode
  onClose: () => void
}

const HeaderSmallModal: React.FC<Props> = ({ children, onClose }) => {
  return (
    <div className="toolbar-modal-header">
      <div className="justify-content-between align-items-center p-2">
        {children}
        <IconButton name={IconName.close} onClick={onClose} />
      </div>
    </div>
  )
}

export default HeaderSmallModal
